<template>
  <div>
    <div
      class="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top"
      style="background-color: #172c30"
    >
      <h4 class="d-flex flex-center rounded-top">
        <span class="text-white">Notificações</span>
        <span
          class="btn btn-text btn-primary btn-sm font-weight-bold btn-font-md ml-2"
        >
          {{ totalNotificacoes }}
        </span>
      </h4>
      <ul
        class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-3 px-8"
        role="tablist"
      >
        <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="0"
            class="nav-link active"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Relatórios
          </a>
        </li>
      </ul>
    </div>

    <b-tabs class="hide-tabs" v-model="tabIndex">
      <b-tab active class="p-8">
        <perfect-scrollbar
          class="scroll pr-7 mr-n7"
          style="max-height: 40vh; position: relative"
        >
          <template v-for="(item, i) in notificacoes">
            <div
              class="d-flex align-items-center mb-6"
              v-bind:key="item.id || i"
            >
              <div
                class="label label-inline label-light-danger mr-5"
                v-if="item.status"
              >
                Pendente
              </div>
              <div
                class="label label-inline label-light-success mr-5"
                v-if="!item.status"
              >
                Visualizada
              </div>
              <div class="d-flex flex-column font-weight-bold flex-grow-1">
                <a
                  @click="abrirNotificacao(item, $event)"
                  :target="item.origin === 'catalogo' ? null : '_blank'"
                  :href="item.action"
                  class="text-dark text-hover-primary mb-1 font-size-lg"
                >
                  {{ item.title }}
                </a>
                <span
                  v-if="item.origin === 'catalogo' && descricaoNotificacaoCatalogo(item)"
                  class="text-muted"
                >
                  {{ descricaoNotificacaoCatalogo(item) }}
                </span>
                <span class="text-muted">
                  {{ formatDate(item.created_at, "DD/MM/YYYY") }}
                </span>
              </div>
              <button
                type="button"
                class="btn btn-xs btn-icon btn-light-danger p-0 ml-3 flex-shrink-0"
                :disabled="excluindoNotificacaoId === item.id"
                v-b-tooltip.hover.left="'Excluir notificação'"
                aria-label="Excluir notificação"
                @click.stop="confirmarExclusaoNotificacao(item)"
              >
                <i class="fa fa-trash font-size-xs"></i>
              </button>
            </div>
          </template>
        </perfect-scrollbar>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
import { SistemaMixin } from "@/modules/Application";
import { mapState } from "vuex";
import { notificationStore } from "../../../../notificationStore";
import { integracaoPosStore } from "../../../../integracaoPosStore";
import {
  getSynchronousReportEventUrl,
  openReportUrl,
} from "@/modules/Relatorios/services/reportGeneration";

export default {
  name: "KTDropdownNotification",
  mixins: [SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      notificacoes: {},
      totalNotificacoes: 0,
      excluindoNotificacaoId: null,
      notificationStore,
      integracaoPosStore,
    };
  },
  watch: {
    totalNotificacoes(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.totalNotificacoes = newValue;
        this.notificationStore.total = newValue;
      }
    },
  },

  methods: {
    listenForReportNotifications() {
      const companyId = this.currentUser?.usuario_empresa?.id_empresa;

      if (!companyId) {
        return;
      }

      const eventName = ".newNotificacaoReport" + companyId;
      const channel = window.Echo.private("notificaoReport" + companyId);

      channel.stopListening(eventName);
      channel.listen(eventName, (message) => {
        if (message) {
          this.getNotificacoes();
        }
      });
    },
    listenForPosNotifications() {
      const companyId = this.currentUser?.usuario_empresa?.id_empresa;

      if (!companyId) {
        return;
      }

      const eventName = ".newNotificacaoPos" + companyId;
      const channel = window.Echo.private("notificaoPos" + companyId);

      channel.stopListening(eventName);
      channel.listen(eventName, (message) => {
        if (message) {
          this.integracaoPosStore = message;
          this.notificationStore.lastPosNotification = message;
        }
      });
    },
    listenForSynchronousReports() {
      const companyId = this.currentUser?.usuario_empresa?.id_empresa;

      if (!companyId) {
        return;
      }

      const channelName = "reportGenerate" + companyId;
      const eventName = ".newReport" + companyId;
      const channel = window.Echo.private(channelName);

      channel.stopListening(eventName);
      channel.listen(eventName, (message) => {
        const reportUrl = getSynchronousReportEventUrl(message);

        if (reportUrl) {
          openReportUrl(reportUrl);
        }
      });
    },
    stopListeningForSynchronousReports() {
      const companyId = this.currentUser?.usuario_empresa?.id_empresa;

      if (!companyId) {
        return;
      }

      window.Echo.private("reportGenerate" + companyId).stopListening(
        ".newReport" + companyId
      );
    },
    stopListeningForNotifications() {
      const companyId = this.currentUser?.usuario_empresa?.id_empresa;

      if (!companyId) {
        return;
      }

      window.Echo.private("notificaoReport" + companyId).stopListening(
        ".newNotificacaoReport" + companyId
      );
      window.Echo.private("notificaoPos" + companyId).stopListening(
        ".newNotificacaoPos" + companyId
      );
    },
    async getDataInit() {
      await this.getNotificacoes();
    },
    async getNotificacoes() {
      try {
        const { data } = await this.$http.post("/notificacao");
        this.notificacoes = data.notificacoes;
        this.totalNotificacoes = data.totalNaoLidas;
      } catch (e) {
        console.log(e);
      }
    },
    abrirNotificacao(item, event) {
      this.atualizaStatus(item.id);
      if (item.origin !== "catalogo") {
        return;
      }

      event.preventDefault();
      if (this.$route.name === "pedidos") {
        this.$root.$emit("catalogo-digital:novos-pedidos");
      } else {
        this.$router.push({ name: "pedidos" });
      }
    },
    descricaoNotificacaoCatalogo(item) {
      try {
        const content =
          typeof item.content === "string"
            ? JSON.parse(item.content)
            : item.content;
        return typeof content?.descricao === "string" ? content.descricao : "";
      } catch (error) {
        return "";
      }
    },
    async atualizaStatus(id) {
      try {
        await this.$http.post("/notificacao/update", {
          id: id,
        });
        await this.getNotificacoes();
      } catch (e) {
        console.log(e);
      }
    },
    async confirmarExclusaoNotificacao(item) {
      if (!item?.id || this.excluindoNotificacaoId !== null) {
        return;
      }

      const result = await this.$swal.fire({
        icon: "warning",
        title: "Excluir notificação?",
        text: "Esta ação não poderá ser desfeita.",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#f64e60",
        reverseButtons: true,
      });

      if (!result.isConfirmed) {
        return;
      }

      this.excluindoNotificacaoId = item.id;

      try {
        await this.$http.post("/notificacao/delete", {
          id: item.id,
        });
        await this.getNotificacoes();
        this.$toast.success("Notificação excluída com sucesso.");
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.msg ||
          "Não foi possível excluir a notificação.";

        this.$toast.error(message);
      } finally {
        this.excluindoNotificacaoId = null;
      }
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
  },
  async mounted() {
    this.listenForReportNotifications();
    this.listenForPosNotifications();
    this.listenForSynchronousReports();
    this.$root.$on("catalogo-digital:novos-pedidos", this.getNotificacoes);
    await this.getDataInit();
  },
  beforeDestroy() {
    this.$root.$off("catalogo-digital:novos-pedidos", this.getNotificacoes);
    this.stopListeningForNotifications();
    this.stopListeningForSynchronousReports();
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    },
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
  },
};
</script>
